import React from "react";
import { useState } from "react";

import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/DownloadApp.js";
import { SectionHeading } from "components/misc/Headings";
import MessageAnimation from "./MessageAnimation";

import chefIconImageSrc from "images/chef-icon.svg";
import celebrationIconImageSrc from "images/celebration-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";
import heroImageSrc from "images/Réduisez vos impôts et augmentez votre épargne avec les experts du réseau IMPOTS REDUC.webp";
import anacofiImageSrc from "images/anacofi-logo-02.webp";
import oriasImageSrc from "images/orais-logo.webp";
import defiscaliserImageSrc from "images/Contactez un expert partenaire d'Impôts Réduc et bénéficiez d'une consultation fiscale gratuite et sans engagement.webp";


export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl md:h-[30vw]`;

  const [isValidNumber, setIsValidNumber] = useState(true);
  const [hasSentPhone, setHasSentPhone] = useState(false);


  return (
    <AnimationRevealPage>
      <Hero
        heading={<>Payez moins d’impôts.  <HighlightedText>Boostez votre épargne.</HighlightedText></>}
        description={<p tw="text-base">Réduisez votre impôt sur le revenu ou sur votre société, optimisez la fiscalité de vos placements actuels ou futurs… En faisant appel à <b>la première plateforme de mise en relation avec des Experts en fiscalité certifiés.</b></p>}
        imageSrc={heroImageSrc}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Appeler maintenant"
        primaryButtonUrl="#appelle-moi"
      />

      <Testimonial
        subheading=""
        heading={<>Ils recommandent <HighlightedText>Impôts Réduc’</HighlightedText></>}
      />
      {/* <MainFeature
        subheading={<Subheading>Established Since 2014</Subheading>}
        heading={
          <>
            We've been serving for
            <wbr /> <HighlightedText>over 5 years.</HighlightedText>
          </>
        }
        description={
          <Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.
            <br />
            <br />
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Latest Offers"
        imageSrc={
          "https://images.unsplash.com/photo-1460306855393-0410f61241c7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      /> */}
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      <TabGrid
        heading={
          <>
             Cumulez les <HighlightedText>avantages fiscaux !</HighlightedText>
          </>
        }
      />
      <section tw="p-6">
  <div tw="overflow-x-auto">
    <table tw="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
      <thead tw="bg-gray-300">
        <tr>
          <th tw="py-3 px-6 text-left font-semibold text-gray-700">Dispositif</th>
          <th tw="py-3 px-6 text-left font-semibold text-gray-700">Usage</th>
          <th tw="py-3 px-6 text-left font-semibold text-gray-700">Réduction d'impôt possible</th>
        </tr>
      </thead>
      <tbody>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200">
          <td tw="py-4 px-6 font-medium text-gray-900">Faites un don, réduisez vos impôts !</td>
          <td tw="py-4 px-6 text-gray-700">Réduction d'impôt pour les dons faits aux organismes d'intérêt général ou reconnus d'utilité publique.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Jusqu'à 75 % dans la limite de 1 000 € par an (et 66 % au-delà)</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Investissez dans l'immobilier et payez moins d’impôts</td>
          <td tw="py-4 px-6 text-gray-700">Réduction d'impôt en investissant dans l'immobilier locatif neuf ou rénové sous conditions (Pinel, Denormandie).</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Jusqu'à 63 000 € sur 12 ans</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Employez à domicile et divisez votre impôt par deux</td>
          <td tw="py-4 px-6 text-gray-700">Crédit d'impôt pour l'embauche d'une aide à domicile : ménage, jardinage, soutien scolaire, etc.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Jusqu'à 50 % des dépenses, dans la limite de 12 000 € par an</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Récompensez la réussite scolaire de vos enfants</td>
          <td tw="py-4 px-6 text-gray-700">Réduction forfaitaire par enfant à charge inscrit au collège, lycée ou enseignement supérieur.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">De 61 € à 183 € par enfant par an</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Soutenez les PME françaises et réduisez vos impôts</td>
          <td tw="py-4 px-6 text-gray-700">Souscription au capital d'une PME pour bénéficier d'une réduction d'impôt.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Jusqu'à 25 % des versements, plafonnés à 50 000 € par an</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Défendez vos droits, allègez votre impôt</td>
          <td tw="py-4 px-6 text-gray-700">Réduction d'impôt à hauteur de 66 % du montant des cotisations syndicales versées.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Dans la limite du montant effectivement versé par an</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Rénovez votre logement et bénéficiez d'aides fiscales</td>
          <td tw="py-4 px-6 text-gray-700">Aides et crédits d'impôt pour la rénovation thermique des logements (MaPrimeRénov').</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Plafonds variables selon les travaux et les revenus</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Préparez votre retraite tout en réduisant vos impôts</td>
          <td tw="py-4 px-6 text-gray-700">Déduction du revenu imposable des versements effectués sur un PER individuel ou collectif.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Jusqu'à 10 % des revenus professionnels nets, plafonné à 35 194 € en 2024</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Déclarez vos déplacements, payez moins d'impôts</td>
          <td tw="py-4 px-6 text-gray-700">Déduction des frais de déplacement domicile-travail selon le barème kilométrique officiel, pour les salariés déclarant leurs frais réels.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Variable selon distance et véhicule (barème kilométrique officiel)</td>
        </tr>
        <tr tw="border-t border-gray-200 even:bg-gray-100 hover:bg-gray-200 max-sm:w-[100%]">
          <td tw="py-4 px-6 font-medium text-gray-900">Aidez vos proches dépendants et bénéficiez d'un crédit d'impôt</td>
          <td tw="py-4 px-6 text-gray-700">Crédit d'impôt possible pour la livraison de repas aux personnes dépendantes, dans le cadre des services à domicile.</td>
          <td tw="py-4 px-6 text-green-600 font-semibold">Inclus dans le plafond de 12 000 € de l'emploi à domicile</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>



      {/* <Features
        heading={
          <>
            Amazing <HighlightedText>Services.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional Chefs",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://timerse.com"
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://reddit.com"
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      /> */}
      <section id="appelle-moi">
      <MainFeature2
        subheading={<Subheading>Experts en économies d’impôts</Subheading>}
        heading={<>Défiscalisez <HighlightedText>dès maintenant !</HighlightedText></>}
        textOnLeft={false}
        statistics={[
          {
            key: "Mises en relation depuis 2020",
            value: "+40000",
          },
          {
            key: "Tous les dispositifs légaux",
            value: "100%"
          },
          {
            key: "D’économies d’impôts en moyenne",
            value: "2500 €/AN"
          }
        ]}
        description={<div>
          <p>Contactez-nous pour bénéficier d’une <b>consultation fiscale gratuite avec un expert certifié</b> par l’Autorité des marchés financiers (AMF). <b>Ce service est anonyme et sans engagement.</b></p>
          
        </div>}
        button={<div>
            {!hasSentPhone && <form tw="mt-5" 
            action="https://formsubmit.co/contact@impots-reduc.fr" 
            method="POST" 
            id="formulaire-appelle-moi"
            onSubmit={(e) => {
               e.preventDefault();
                const phoneNumber = e.target.querySelector('input[type="tel"]').value.trim();
                const errorMessage = document.getElementById('error-message');
                const submitButton = document.getElementById('submit-button');

                // Validation on submit
                if (!phoneNumber) {
                  errorMessage.textContent = 'Veuillez saisir votre numéro de téléphone';
                  e.target.querySelector('input[type="tel"]').style.border = '2px solid #EF4444';
                  submitButton.disabled = true;
                  return;
                }

                // If validation passes, submit the form
                fetch("https://formsubmit.co/ajax/contact@impots-reduc.fr", {
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    "Numéro de téléphone": phoneNumber
                })
            })
                .then(response => response.json())
                .then(data => console.log(data))
                .catch(error => console.log(error));
                setHasSentPhone(true);

              // trigger event for google tags tracking
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'phone_number_submission'
              });

                // e.target.submit();
            }}
            >
              <input type="hidden" name="_template" value="box"></input>
              <input type="hidden" name="_captcha" value="false"></input>
              <input type="hidden" name="_subject" value="Appelez moi!"></input>
              <div tw="flex h-16 gap-3 items-center">
                <input 
                  type="tel" 
                  name="Numéro de téléphone" 
                  inputmode="numeric"
                  placeholder="Votre numéro de téléphone"
                  tw={"w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-green-500  border-2 placeholder-gray-500 text-sm focus:outline-none focus:border-green-400 focus:bg-white mt-5 first:mt-0 max-sm:text-xs max-sm:px-2"}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.trim().replaceAll(" ", "");
                    const errorMessage = document.getElementById('error-message');
                    const submitButton = document.getElementById('submit-button');
                    setIsValidNumber(false);

                    // Reset styles
                    e.target.style.border = '';
                    errorMessage.textContent = '';

                    // Validation
                    if (!phoneNumber) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Veuillez saisir votre numéro de téléphone';
                      return;
                    }

                    // Check if starts with 0
                    if (!phoneNumber.startsWith('0')) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro doit commencer par 0';
                      return;
                    }

                    // Check if contains only numbers
                    if (!/^\d+$/.test(phoneNumber)) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro ne doit contenir que des chiffres';
                      return;
                    }

                    
                    
                    // Check if it starts with 08
                    if (/^8/.test(phoneNumber.slice(1))) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro ne doit pas commencer avec 08';
                      return;
                    }
                    
                    // Check length (must be exactly 10 digits)
                    if (phoneNumber.length !== 10) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro doit contenir exactement 10 chiffres';
                      return;
                    }
                    

                    // Valid input
                    setIsValidNumber(true);
                    e.target.style.border = '2px solid #10B981';
                    submitButton.disabled = false;
                  }}
                />
              <button id="submit-button" disabled={!isValidNumber} tw="flex text-base items-center justify-center lg:mx-0 h-[80%] px-6 py-2 box-border rounded bg-primary-500 text-gray-100 font-bold hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline border-b-0 max-sm:text-xs max-sm:p-2  disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:hover:bg-gray-400" type="submit" form="formulaire-appelle-moi">Parler à un conseiller</button>
              </div>
              <div id="error-message" tw="text-red-500 text-sm mt-2"></div>
            </form>}
            <span tw="font-medium text-lg text-secondary-400">Ou contactez <span  tw="bg-gray-100 transform -skew-x-12 inline-block font-bold text-secondary-500">Impôts Réduc'</span> directement au <a href="tel:+33485696407" tw="bg-gray-100 transform inline-block font-bold text-secondary-500">04.85.69.64.07</a></span>
            <MessageAnimation 
              message="Demande de rappel reçue. Un conseiller vous contactera dans un délai de 48 heures. A bientôt!"
              hasSentMessage={hasSentPhone}
            />
          </div>}
        primaryButtonText="Order Now"
        primaryButtonUrl="https://order.now.com"
        imageInsideDiv={false}
        imageSrc={defiscaliserImageSrc}
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
      />

      </section>
    
      {/* <DownloadApp
        text={<>People around you are ordering delicious meals using the <HighlightedTextInverse>Treact App.</HighlightedTextInverse></>}
      /> */}

      <section tw="my-10">
        <SectionHeading>Nos <HighlightedText>Partenaires</HighlightedText></SectionHeading>
        <p tw="mt-4 mb-6 text-center max-md:text-left text-base md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100">Tous nos partenaires-experts en fiscalité sont signataires de notre charte qualité et certifiés par :</p>
        <div tw="flex flex-wrap justify-center gap-[20%]">
          <img src={anacofiImageSrc} alt="anacofi logo" tw="w-[25%] min-w-[300px] max-md:w-[75%]"/>
          <img src={oriasImageSrc} alt="orias logo" tw="w-[25%] min-w-[300px] max-md:w-[75%]"/>
        </div>
      </section>
    </AnimationRevealPage>
  );
}
